import React from 'react';

import LinkTree from './LinkTree'

import './App.css';

function App() {
  return (
    <div className="App">
      <LinkTree/>
    </div>
  );
}

export default App;
